export default __webpack_public_path__ + "static/media/teleconsult-on-demand-4.38c5d08a.png";